import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
   CHARGE_ALREADY_CANCELED,
   CHARGE_INDEX_OUT_OF_BOUNDS,
   CHARGE_MISMATCH,
   CHARGE_NOT_CANCELABLE,
   DISTRIBUTION_CENTER_ALREADY_EXISTS,
   EMAIL_ALREADY_EXISTS,
   ORDER_ADDITIONAL_CHARGE_AMOUNT_EXCEEDED,
   ORDER_ADDITIONAL_CHARGE_DAMAGED_AND_LOST_AMOUNT_EXCEEDED,
   ORDER_INVALID_STATUS,
} from './errorCodes';

export const useErrorDescriptions = () => {
   const { t } = useTranslation();

   return useMemo(() => {
      const DEFAULT_ERROR_DESCRIPTIONS = {
         UNKNOWN: t('errors.default.unknown'),
         FETCH_DATA: t('errors.default.fetch_data'),
         COMPLETE_ACTION: t('errors.default.complete_action'),
         COMPLETE_ACTION_SHORT: t('errors.default.complete_action_short'),
      };

      const ADD_ADDITIONAL_CHARGES_ERROR_DESCRIPTIONS: Record<string, string> = {
         [ORDER_ADDITIONAL_CHARGE_AMOUNT_EXCEEDED]: t('errors.additional_charge.amount_exceeded'),
         [ORDER_ADDITIONAL_CHARGE_DAMAGED_AND_LOST_AMOUNT_EXCEEDED]: t(
            'errors.additional_charge.damaged_or_lost_exceeded',
         ),
         OTHER: t('errors.additional_charge.other'),
      };

      const CANCEL_ADDITIONAL_CHARGE_ERROR_DESCRIPTIONS: Record<string, string> = {
         [CHARGE_MISMATCH]: t('errors.delete_charge.stale_data'),
         [CHARGE_INDEX_OUT_OF_BOUNDS]: t('errors.delete_charge.stale_data'),
         [CHARGE_ALREADY_CANCELED]: t('errors.delete_charge.already_deleted'),
         [CHARGE_NOT_CANCELABLE]: t('errors.delete_charge.not_deletable'),
         [ORDER_INVALID_STATUS]: t('errors.delete_charge.invalid_order_status'),
         OTHER: t('errors.delete_charge.other'),
      };

      const ADD_OR_EDIT_CLIENT_ERROR_DESCRIPTIONS: Record<string, string> = {
         [EMAIL_ALREADY_EXISTS]: t('errors.client.email_exists'),
      };

      const ADD_STORAGE_POINT_ERROR_DESCRIPTIONS: Record<string, string> = {
         [EMAIL_ALREADY_EXISTS]: t('errors.storage_point.email_exists'),
      };

      const ADD_OR_EDIT_DISTRIBUTION_CENTER_ERROR_DESCRIPTIONS: Record<string, string> = {
         [DISTRIBUTION_CENTER_ALREADY_EXISTS]: t('errors.distribution_center.address_exists'),
         [EMAIL_ALREADY_EXISTS]: t('errors.storage_point.email_exists'),
      };

      const CREATE_AND_SEND_INVOICE_ERROR_DESCRIPTION = t('errors.invoice_creation_failed');

      return {
         DEFAULT_ERROR_DESCRIPTIONS,
         ADD_ADDITIONAL_CHARGES_ERROR_DESCRIPTIONS,
         CANCEL_ADDITIONAL_CHARGE_ERROR_DESCRIPTIONS,
         ADD_OR_EDIT_CLIENT_ERROR_DESCRIPTIONS,
         ADD_STORAGE_POINT_ERROR_DESCRIPTIONS,
         ADD_OR_EDIT_DISTRIBUTION_CENTER_ERROR_DESCRIPTIONS,
         CREATE_AND_SEND_INVOICE_ERROR_DESCRIPTION,
      };
   }, [t]);
};
